import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { FamilyTree } from '../../../app/api/generated/client';
import { getFamilyTree } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useFamilyTree(partnerUuid?: string): UseQueryResult<FamilyTree, AxiosError> {
    return useQuery({
        queryKey: queryKeys.familyTree(partnerUuid!),
        queryFn: ({ signal }) => getFamilyTree({ path: { partnerUuid: partnerUuid! }, signal }).then((result) => result.data),
        enabled: !!partnerUuid,
    });
}
